import { useQuery } from '@tanstack/react-query';
import { dashboard2 } from '@/api/dms/generated/sdk.gen';
import { useAuth } from '@/context/AuthContext';

export function useCalibrationAlertCount() {
  const { token } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ['calibration', 'alert-count'],
    queryFn: async () => {
      const { data } = await dashboard2({ throwOnError: true });
      return { count: (data.overdue ?? 0) + (data.approaching ?? 0) };
    },
    enabled: !!token,
    refetchInterval: 60_000,
    retry: false,
  });

  return {
    count: data?.count ?? 0,
    isLoading,
  };
}
